<template>
  <div id="app">
    <v-app id="inspire" v-if="! page_loading">

      <app-header-component></app-header-component>

      <v-content>
        <v-container>

          <BackMenuComponent></BackMenuComponent>

          <router-view></router-view>

          <SnackBarComponent></SnackBarComponent>

        </v-container>
        <FooterComponent v-if="isLogged"></FooterComponent>
      </v-content>

      <NotifyComponent></NotifyComponent>
    </v-app>

    <v-app id="inspire" v-if="page_loading">

      <v-content>
        <v-container fluid fill-height>
          <v-layout row align-center justify-center mt-4>
            <tile :loading="true" color="#1a9907"></tile>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
    import BackMenuComponent from './components/shared/BackMenuComponent';
    import SnackBarComponent from './components/shared/SnackBarComponent';
    import FooterComponent from './components/shared/FooterComponent';
    import NotifyComponent from './components/shared/NotifyComponent';

    import { DICCIONARIO } from './diccionario';

    export default {
        data: () => ({
            drawer: null,
            diccionary: DICCIONARIO
        }),
        props: {
            source: String
        },
        mounted () {
          this.$validator.localize('en', this.dictionary)
        },
        computed : {
            role : function(){
                return this.$store.getters.getRole;
            },
            page_loading : function(){
                return this.$store.getters.getPageLoading;
            },
            isLogged : function(){
              return this.$store.getters.isLogged;
            },
        },
        created () {
        },
        components : {
            BackMenuComponent,
            SnackBarComponent,
            FooterComponent,
          NotifyComponent
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue